import { gql } from "@grandvisionhq/graphql";
import { savedUserDetails } from "../../../fragments/operations/fragments/saved-user-details.js";
const GET_SAVED_USER_DETAILS = gql`
  query GetSavedUserDetails {
    me {
      id
      ...SavedUserDetailsFragment
      preferredStore {
        globalStoreId
      }
    }
  }
  ${savedUserDetails}
`;
export {
  GET_SAVED_USER_DETAILS
};
//# sourceMappingURL=get-user-details.js.map
